/** Clarity One luxury portal palette — aligned with proposals & The Clarity Club. */
export const CLARITY_ONE_COLORS = {
  cream: "#F9F7F2",
  creamDark: "#F0EDE6",
  navy: "#1A2744",
  navyHover: "#243556",
  gold: "#B8956E",
  goldLight: "#C8A96A",
  bronze: "#8B7355",
  white: "#FFFFFF",
  border: "#E8E4DC",
} as const;

export const CLARITY_ONE_FONT =
  '"Helvetica Neue", "HelveticaNeue-Light", Helvetica, Arial, sans-serif';
